module.exports = __webpack_public_path__ + "img/rahman-s.05cb5c63.png";